import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=39e3962e&"
import script from "./LinkItem.vue?vue&type=script&lang=ts&"
export * from "./LinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./LinkItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports